import { render } from "./AlgoliaInput.vue?vue&type=template&id=0bcd9b5c&scoped=true"
import script from "./AlgoliaInput.vue?vue&type=script&lang=js"
export * from "./AlgoliaInput.vue?vue&type=script&lang=js"

import "./AlgoliaInput.vue?vue&type=style&index=0&id=0bcd9b5c&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bcd9b5c"]])

export default __exports__